import { Injectable } from '@angular/core';
import * as myGlobals from '../shared/globalcontants';
import { HttpRequestService } from '../shared/services/http-request.service';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OfflineService {
  public toastMessage = '';
  public selectedTab: any = {};
  public disableAll: BehaviorSubject<boolean[]> = new BehaviorSubject<boolean[]>([false, false, false, false, false, false]);
  public firstTimeLoad = false;
  public requisitionFilter: any = [];
  public requisitionSort: any;
  public transferFilter: any = [];
  public transferSort: any;
  public poFilter: any = [];
  public poSort: any;
  public spoilageFilter: any = [];
  public receivingFilter: any = [];
  public piFilter: any = [];
  public spoilageSort: any;

  public showNavigtaionTab = true;
}
